import React from "react";
import "./BranchErrorOverlay.scss";
import { useAppSelector } from "../../Redux/store";


const BranchErrorOverlay = () => {
    const branchError = useAppSelector((state) => state.overall.branchError);
    console.log()
    if (!branchError) return null;

    return (
        <div className="branch-error-overlay">
            <div className="branch-error-box">
                {branchError}
            </div>
        </div>
    );
};

export default React.memo(BranchErrorOverlay);